import { render, staticRenderFns } from "./AttendancePreferenceSettings.vue?vue&type=template&id=65fcaa38"
import script from "./AttendancePreferenceSettings.vue?vue&type=script&lang=js"
export * from "./AttendancePreferenceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports